var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeneric(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.754,
    height: 29.068,
    viewBox: "0 0 18.754 29.068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#b1b1f8;}.b{fill:#4b4495;}.c{fill:#48d1cc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.002 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15003.091,5389.579h-15.436a1.574,1.574,0,0,1-1.657-1.472v-14.543a6.715,6.715,0,0,1,2.761-5.34v-1.732a.523.523,0,0,1,.55-.49h12.129a.525.525,0,0,1,.554.49v1.732a6.708,6.708,0,0,1,2.753,5.34v14.543A1.572,1.572,0,0,1,15003.091,5389.579Zm-10.477-11.843a.553.553,0,0,0-.55.554v1.1a.551.551,0,0,0,.55.55h1.657v1.653a.553.553,0,0,0,.55.554h1.1a.553.553,0,0,0,.55-.554v-1.653h1.653a.552.552,0,0,0,.553-.55v-1.1a.554.554,0,0,0-.553-.554h-1.653v-1.653a.551.551,0,0,0-.55-.55h-1.1a.551.551,0,0,0-.55.55v1.653Z",
    transform: "translate(-14986 -5361.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15004.194,5366h-17.643a.518.518,0,0,0-.552.478v9.549a.519.519,0,0,0,.552.478h17.643a.518.518,0,0,0,.551-.478c0-5.073.021-8.582-.011-9.285S15004.341,5366,15004.194,5366Z",
    transform: "translate(-14986 -5353.585)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18.437,3H6.308A1.555,1.555,0,0,0,4.654,4.432V7.3a1.462,1.462,0,0,0,1.1,1.346,1.739,1.739,0,0,0,.551.086H18.437a1.739,1.739,0,0,0,.551-.086,1.462,1.462,0,0,0,1.1-1.346V4.432A1.555,1.555,0,0,0,18.437,3Z",
    transform: "translate(-2.997 -4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M20.065,36.205H18.411V34.551A.551.551,0,0,0,17.859,34h-1.1a.551.551,0,0,0-.551.551v1.654H14.551a.551.551,0,0,0-.551.551v1.1a.551.551,0,0,0,.551.551h1.654v1.654a.551.551,0,0,0,.551.551h1.1a.551.551,0,0,0,.551-.551V38.411h1.654a.551.551,0,0,0,.551-.551v-1.1A.551.551,0,0,0,20.065,36.205Z",
    transform: "translate(-7.936 -19.979)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric);
export default __webpack_public_path__ + "static/media/generic.a67e37e5cdb91f0ac401abcaa6aa1998.svg";
export { ForwardRef as ReactComponent };